export default __webpack_public_path__ + "static/media/40196.6da90382.jpg";